import Vue from 'vue';
import { forEach } from 'lodash-es';
import {
  birthDateMask,
  echeanceMask,
  cciNumberMask,
  ibanNumberMask,
  numberMask,
  oriasMask,
  siretMask,
  phoneMask,
} from '@/utils/mask';

const masks = {
  cci: cciNumberMask,
  birthdate: birthDateMask,
  echeance: echeanceMask,
  iban: ibanNumberMask,
  number: numberMask,
  orias: oriasMask,
  siret: siretMask,
  phone: phoneMask,
};

forEach(masks, (value, key) => {
  Vue.directive(key, {
    // When the bound element is inserted into the DOM...
    inserted(el, binding) {
      const number = binding.value;
      const { options } = binding.value;
      const wrapper = value(el, options);
      if (number.getValue) {
        wrapper.value = `${number.getValue}`;
      }
      wrapper.on('accept', () => {
        if (options && options.setWithMask) {
          number.setValue(wrapper.value);
        } else {
          number.setValue(wrapper.unmaskedValue);
        }
      });
    },
  });
});
